"use strict";

var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBridgeHistory = exports.useRelayTx = exports.useBridge = exports.useGetBridgeData = exports.useWithinBridgeLimits = exports.useGetBridgeContracts = void 0;
var lodash_1 = require("lodash");
var sdk_js_1 = require("@gooddollar/bridge-app/dist/sdk.js");
var TokenBridge_json_1 = __importDefault(require("@gooddollar/bridge-contracts/artifacts/contracts/bridge/TokenBridge.sol/TokenBridge.json"));
var deployment_json_1 = __importDefault(require("@gooddollar/bridge-contracts/release/deployment.json"));
var core_1 = require("@usedapp/core");
var ethers_1 = require("ethers");
var lodash_2 = require("lodash");
var react_1 = require("react");
var contexts_1 = require("../../contexts");
var useRefreshOrNever_1 = __importDefault(require("../../hooks/useRefreshOrNever"));
var react_2 = require("../base/react");
var constants_1 = require("../constants");
var useGasFees_1 = require("../base/hooks/useGasFees");
var useGetBridgeContracts = function useGetBridgeContracts() {
  var _ref = (0, react_2.useGetEnvChainId)(),
    baseEnv = _ref.baseEnv;
  var _ref2 = deployment_json_1.default[baseEnv] || {},
    fuseBridge = _ref2.fuseBridge,
    celoBridge = _ref2.celoBridge;
  if (fuseBridge && celoBridge) {
    var _ref3;
    return _ref3 = {}, _defineProperty(_ref3, constants_1.SupportedChains.FUSE, new ethers_1.Contract(fuseBridge, TokenBridge_json_1.default.abi)), _defineProperty(_ref3, constants_1.SupportedChains.CELO, new ethers_1.Contract(celoBridge, TokenBridge_json_1.default.abi)), _ref3;
  } else return {};
};
exports.useGetBridgeContracts = useGetBridgeContracts;
var useWithinBridgeLimits = function useWithinBridgeLimits(requestChainId, account, amount) {
  var _a;
  var bridgeContract = (0, exports.useGetBridgeContracts)()[requestChainId];
  var canBridge = (0, core_1.useCalls)([{
    contract: bridgeContract,
    method: "canBridge",
    args: [account, amount]
  }].filter(function () {
    return bridgeContract && account && amount;
  }), {
    refresh: "never",
    chainId: requestChainId
  });
  var _ref4 = ((_a = canBridge === null || canBridge === void 0 ? void 0 : canBridge[0]) === null || _a === void 0 ? void 0 : _a.value) || [],
    _ref5 = _slicedToArray(_ref4, 2),
    _ref5$ = _ref5[0],
    isValid = _ref5$ === void 0 ? false : _ref5$,
    _ref5$2 = _ref5[1],
    reason = _ref5$2 === void 0 ? "" : _ref5$2;
  return {
    isValid: isValid,
    reason: reason
  };
};
exports.useWithinBridgeLimits = useWithinBridgeLimits;
var useGetBridgeData = function useGetBridgeData(requestChainId, account) {
  var _a, _b, _c, _d;
  var bridgeContract = (0, exports.useGetBridgeContracts)()[requestChainId];
  var results = (0, core_1.useCalls)([{
    contract: bridgeContract,
    method: "bridgeFees",
    args: []
  }, {
    contract: bridgeContract,
    method: "bridgeLimits",
    args: []
  }, {
    contract: bridgeContract,
    method: "bridgeDailyLimit",
    args: []
  }, account && {
    contract: bridgeContract,
    method: "accountsDailyLimit",
    args: [account]
  }].filter(function (_) {
    return _ && bridgeContract;
  }), {
    refresh: "never",
    chainId: requestChainId
  });
  return {
    bridgeFees: (_a = results === null || results === void 0 ? void 0 : results[0]) === null || _a === void 0 ? void 0 : _a.value,
    bridgeLimits: (_b = results === null || results === void 0 ? void 0 : results[1]) === null || _b === void 0 ? void 0 : _b.value,
    bridgeDailyLimit: (_c = results === null || results === void 0 ? void 0 : results[2]) === null || _c === void 0 ? void 0 : _c.value,
    accountDailyLimit: (_d = results === null || results === void 0 ? void 0 : results[3]) === null || _d === void 0 ? void 0 : _d.value
  };
};
exports.useGetBridgeData = useGetBridgeData;
var useBridge = function useBridge() {
  var withRelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;
  var lock = (0, react_1.useRef)(false);
  var _ref6 = (0, contexts_1.useSwitchNetwork)(),
    switchNetwork = _ref6.switchNetwork;
  var _ref7 = (0, core_1.useEthers)(),
    account = _ref7.account,
    chainId = _ref7.chainId;
  var g$Contract = (0, react_2.useGetContract)("GoodDollar");
  var bridgeContracts = (0, exports.useGetBridgeContracts)();
  var bridgeContract = bridgeContracts[chainId || 122];
  var relayTx = (0, exports.useRelayTx)();
  var _ref8 = (0, react_1.useState)(),
    _ref9 = _slicedToArray(_ref8, 2),
    bridgeRequest = _ref9[0],
    setBridgeRequest = _ref9[1];
  var _ref10 = (0, react_1.useState)(),
    _ref11 = _slicedToArray(_ref10, 2),
    selfRelayStatus = _ref11[0],
    setSelfRelay = _ref11[1];
  // const bridgeTo = useContractFunction(bridgeContract, "bridgeTo", {});
  var transferAndCall = (0, useGasFees_1.useContractFunctionWithDefaultGasFees)(g$Contract, "transferAndCall");
  var bridgeRequestId = (_e = (_d = (_c = (((_b = (_a = transferAndCall.state) === null || _a === void 0 ? void 0 : _a.receipt) === null || _b === void 0 ? void 0 : _b.logs) || []).filter(function (log) {
    return log.address === bridgeContract.address;
  }).map(function (log) {
    return bridgeContract.interface.parseLog(log);
  })) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.args) === null || _e === void 0 ? void 0 : _e.id;
  // poll target chain for transfer if bridgeRequestEvent was found
  var relayEvent = (0, core_1.useLogs)(bridgeRequest && bridgeRequestId && {
    contract: (_f = bridgeContracts[bridgeRequest.targetChainId]) !== null && _f !== void 0 ? _f : {
      address: ethers_1.ethers.constants.AddressZero
    },
    event: "ExecutedTransfer",
    args: [null, null, null, null, null, null, null, bridgeRequestId]
  }, {
    refresh: (0, useRefreshOrNever_1.default)(bridgeRequestId ? 5 : "never"),
    chainId: bridgeRequest === null || bridgeRequest === void 0 ? void 0 : bridgeRequest.targetChainId,
    fromBlock: -1000
  });
  var relayStatus = relayEvent && {
    chainId: bridgeRequest === null || bridgeRequest === void 0 ? void 0 : bridgeRequest.targetChainId,
    status: ((_g = relayEvent === null || relayEvent === void 0 ? void 0 : relayEvent.value) === null || _g === void 0 ? void 0 : _g.length) ? "Success" : "Mining",
    transaction: {
      hash: (_j = (_h = relayEvent === null || relayEvent === void 0 ? void 0 : relayEvent.value) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.transactionHash
    }
  };
  var sendBridgeRequest = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(amount, sourceChain) {
      var target,
        targetChainId,
        sourceChainId,
        _args2 = arguments;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            target = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : account;
            setBridgeRequest(undefined);
            lock.current = false;
            transferAndCall.resetState();
            targetChainId = sourceChain === "fuse" ? constants_1.SupportedChains.CELO : constants_1.SupportedChains.FUSE;
            sourceChainId = sourceChain === "fuse" ? constants_1.SupportedChains.FUSE : constants_1.SupportedChains.CELO;
            _context2.next = 8;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (!(sourceChainId !== chainId)) {
                      _context.next = 3;
                      break;
                    }
                    _context.next = 3;
                    return switchNetwork(sourceChainId);
                  case 3:
                    setBridgeRequest({
                      amount: amount,
                      sourceChainId: sourceChainId,
                      targetChainId: targetChainId,
                      target: target
                    });
                  case 4:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }))().catch(lodash_1.noop);
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x, _x2) {
      return _ref12.apply(this, arguments);
    };
  }(), [transferAndCall, switchNetwork, setBridgeRequest, chainId]);
  // trigger the actual bridge request
  (0, react_1.useEffect)(function () {
    if (transferAndCall.state.status === "None" && bridgeRequest && account && !lock.current) {
      var withoutRelay = false;
      lock.current = true;
      // we use transfer and call to save the approve step
      var encoded = ethers_1.ethers.utils.defaultAbiCoder.encode(["uint256", "address", "bool"], [bridgeRequest.targetChainId, bridgeRequest.target || account, withoutRelay]);
      transferAndCall.send(bridgeContract.address, bridgeRequest.amount, encoded).then( /*#__PURE__*/function () {
        var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(sendTx) {
          var relayTxHash, _yield$relayTx, _yield$relayTx$relayT, txHash, relayPromise;
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                if (!(sendTx && withRelay)) {
                  _context3.next = 21;
                  break;
                }
                relayTxHash = "";
                _context3.prev = 2;
                setSelfRelay({
                  status: "None",
                  transaction: {}
                });
                _context3.next = 6;
                return relayTx(chainId || 0, bridgeRequest.targetChainId, sendTx.transactionHash);
              case 6:
                _yield$relayTx = _context3.sent;
                _yield$relayTx$relayT = _yield$relayTx.relayTxHash;
                txHash = _yield$relayTx$relayT === void 0 ? "" : _yield$relayTx$relayT;
                relayPromise = _yield$relayTx.relayPromise;
                relayTxHash = txHash;
                setSelfRelay({
                  chainId: chainId,
                  status: relayTxHash ? "Mining" : "Fail",
                  transaction: {
                    hash: relayTxHash
                  }
                });
                _context3.next = 14;
                return relayPromise;
              case 14:
                setSelfRelay({
                  status: "Success",
                  chainId: chainId,
                  transaction: {
                    hash: relayTxHash
                  }
                });
                _context3.next = 21;
                break;
              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](2);
                console.log("transferAndCall catch:", {
                  e: _context3.t0
                });
                setSelfRelay(_objectSpread(_objectSpread({}, selfRelayStatus), {}, {
                  status: "Exception",
                  chainId: chainId,
                  errorMessage: _context3.t0.message,
                  transaction: {
                    hash: relayTxHash
                  }
                }));
              case 21:
              case "end":
                return _context3.stop();
            }
          }, _callee3, null, [[2, 17]]);
        }));
        return function (_x3) {
          return _ref14.apply(this, arguments);
        };
      }()).catch(lodash_1.noop);
    }
  }, [bridgeContract, bridgeRequest, transferAndCall, lock]);
  return {
    sendBridgeRequest: sendBridgeRequest,
    bridgeRequestStatus: transferAndCall === null || transferAndCall === void 0 ? void 0 : transferAndCall.state,
    relayStatus: relayStatus,
    selfRelayStatus: selfRelayStatus
  };
};
exports.useBridge = useBridge;
var delay = function delay(millis) {
  return new Promise(function (res) {
    return setTimeout(res, millis);
  });
};
var useRelayTx = function useRelayTx() {
  var contracts = (0, exports.useGetBridgeContracts)();
  var _ref15 = (0, core_1.useEthers)(),
    library = _ref15.library,
    chainId = _ref15.chainId;
  var _ref16 = (0, contexts_1.useSwitchNetwork)(),
    switchNetwork = _ref16.switchNetwork;
  var _ref17 = (0, react_2.useGetEnvChainId)(),
    baseEnv = _ref17.baseEnv;
  var _ref18 = deployment_json_1.default[baseEnv] || {},
    _ref18$registry = _ref18.registry,
    registry = _ref18$registry === void 0 ? "0x44a1E0A83821E239F9Cef248CECc3AC5b910aeD2" : _ref18$registry;
  var signer = library === null || library === void 0 ? void 0 : library.getSigner();
  var sdk = new sdk_js_1.BridgeSDK(registry, (0, lodash_2.mapValues)(contracts, function (_) {
    return _ === null || _ === void 0 ? void 0 : _.address;
  }), 50);
  var relayTx = (0, react_1.useCallback)( /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(sourceChain, targetChain, txHash) {
      var relayResult, targetBalance;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            if (relayResult) {
              _context4.next = 26;
              break;
            }
            _context4.prev = 1;
            if (!(chainId !== targetChain)) {
              _context4.next = 5;
              break;
            }
            _context4.next = 5;
            return switchNetwork(targetChain);
          case 5:
            _context4.next = 7;
            return signer.getBalance();
          case 7:
            targetBalance = _context4.sent;
            if (!targetBalance.lt(ethers_1.ethers.utils.parseEther("0.01"))) {
              _context4.next = 10;
              break;
            }
            throw new Error("not enough balance for self relay: ".concat((0, constants_1.formatAmount)(targetBalance, 18, 18)));
          case 10:
            _context4.next = 12;
            return sdk.relayTx(sourceChain, targetChain, txHash, signer);
          case 12:
            relayResult = _context4.sent;
            return _context4.abrupt("return", relayResult);
          case 16:
            _context4.prev = 16;
            _context4.t0 = _context4["catch"](1);
            if (!(!_context4.t0.message.includes("does not exists yet") && !_context4.t0.message.includes("txhash/targetReceipt not found"))) {
              _context4.next = 22;
              break;
            }
            throw _context4.t0;
          case 22:
            _context4.next = 24;
            return delay(30000);
          case 24:
            _context4.next = 0;
            break;
          case 26:
            return _context4.abrupt("return", {});
          case 27:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[1, 16]]);
    }));
    return function (_x4, _x5, _x6) {
      return _ref19.apply(this, arguments);
    };
  }(), [sdk, signer, switchNetwork, chainId]);
  return relayTx;
};
exports.useRelayTx = useRelayTx;
var useBridgeHistory = function useBridgeHistory() {
  var _a, _b;
  var bridgeContracts = (0, exports.useGetBridgeContracts)();
  var refresh = (0, useRefreshOrNever_1.default)(12);
  var fuseOut = (0, core_1.useLogs)({
    contract: bridgeContracts[122],
    event: "BridgeRequest",
    args: []
  }, {
    chainId: 122,
    fromBlock: -2e5,
    refresh: refresh
  });
  var fuseIn = (0, core_1.useLogs)({
    contract: bridgeContracts[122],
    event: "ExecutedTransfer",
    args: []
  }, {
    chainId: 122,
    fromBlock: -2e5,
    refresh: refresh
  });
  var celoOut = (0, core_1.useLogs)({
    contract: bridgeContracts[42220],
    event: "BridgeRequest",
    args: []
  }, {
    chainId: 42220,
    fromBlock: -2e5,
    refresh: refresh
  });
  var celoIn = (0, core_1.useLogs)({
    contract: bridgeContracts[42220],
    event: "ExecutedTransfer",
    args: []
  }, {
    chainId: 42220,
    fromBlock: -2e5,
    refresh: refresh
  });
  var celoExecuted = (0, lodash_2.groupBy)((celoIn === null || celoIn === void 0 ? void 0 : celoIn.value) || [], function (_) {
    return _.data.id;
  });
  var fuseExecuted = (0, lodash_2.groupBy)((fuseIn === null || fuseIn === void 0 ? void 0 : fuseIn.value) || [], function (_) {
    return _.data.id;
  });
  var fuseHistory = (_a = fuseOut === null || fuseOut === void 0 ? void 0 : fuseOut.value) === null || _a === void 0 ? void 0 : _a.map(function (e) {
    var extended = e;
    extended.relayEvent = (0, lodash_2.first)(celoExecuted[e.data.id]);
    extended.amount = (0, constants_1.formatAmount)(e.data.amount, 18); //amount is normalized to 18 decimals in the bridge
    return extended;
  });
  var celoHistory = (_b = celoOut === null || celoOut === void 0 ? void 0 : celoOut.value) === null || _b === void 0 ? void 0 : _b.map(function (e) {
    var extended = e;
    extended.relayEvent = (0, lodash_2.first)(fuseExecuted[e.data.id]);
    extended.amount = (0, constants_1.formatAmount)(e.data.amount, 18); //amount is normalized to 18 decimals in the bridge
    return extended;
  });
  return {
    fuseHistory: fuseHistory,
    celoHistory: celoHistory
  };
};
exports.useBridgeHistory = useBridgeHistory;